import { combineReducers, configureStore } from '@reduxjs/toolkit';
import appReducer from '../../features/app/reducers/appSlice';
import assetsReducer from '../../features/app/reducers/assets/assetsSlice';
import tagsReducer from '../../features/app/reducers/tags/tagsSlice';
import { assetsApi } from '../../features/services/assetsApi';
import { contractsApi } from '../../features/services/contractsApi';
import langReducer from '../lang/langSlice';
import loginReducer from '../login/loginSlice';
import tokenHandlingReducer from '../tokenHandling/tokenHandlingSlice';
import { latamContractsApi } from '../../features/services/latamContractsApi';

export const rootReducer = combineReducers({
    lang: langReducer,
    app: appReducer,
    login: loginReducer,
    tokenHandling: tokenHandlingReducer,
    assets: assetsReducer,
    tags: tagsReducer,
    [assetsApi.reducerPath]: assetsApi.reducer,
    [contractsApi.reducerPath]: contractsApi.reducer,
    [latamContractsApi.reducerPath]: latamContractsApi.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware().concat(assetsApi.middleware, contractsApi.middleware, latamContractsApi.middleware),
        preloadedState: preloadedState,
    });

export const store = setupStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
